export default [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/index/Index')
  },
  {
    path: '/list',
    name: 'List',
    component: () => import('@/views/index/List')
  },
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('@/views/index/Detail')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/index/Register')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/index/Login')
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('@/views/index/Forget')
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('@/views/index/My')
  },
  {
    path: '/last',
    name: 'Last',
    component: () => import('@/views/index/Last')
  },
  {
    path: '/recommend',
    name: 'Recommend',
    component: () => import('@/views/index/Recommend')
  },
  {
    path: '/hot',
    name: 'Hot',
    component: () => import('@/views/index/Hot')
  },
  {
    path: '/my/collection',
    name: 'MyCollection',
    component: () => import('@/views/index/MyCollection')
  },
  {
    path: '/my/buy',
    name: 'MyBuy',
    component: () => import('@/views/index/MyBuy')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/index/Search')
  },
  {
    path: '/my/recharge',
    name: 'MyRecharge',
    component: () => import('@/views/index/RechargeLog')
  },
  {
    path: '/xiaoheiwu',
    name: 'Heiwu',
    component: () => import('@/views/index/Heiwu')
  },
  {
    path: '/xuzhi',
    name: 'Xuzhi',
    component: () => import('@/views/index/Xuzhi')
  },
  {
    path: '/payResult',
    name: 'payResult',
    component: () => import('@/views/index/PayResult')
  }
];


// WEBPACK FOOTER //
// ./src/router/btoc.js